import React from 'react';
import { Svg } from '@tradingblock/components';

export const Logo = () => {
  return <Svg path="icon-logo" label="Dashboards" />;
};
